import React from 'react'
import { useTranslation } from 'react-i18next'
import { SecondaryButton } from 'components/Shared/Button'
import { useEditEventSeriesContext } from '../EditEventSeriesProvider'
import PropTypes from 'prop-types'

export default function Toolbar(props) {
  const { className, events, isDisabled } = props
  const { t, i18n } = useTranslation()
  const {
    isSelecting,
    setIsSelecting,
    selectAllEvents,
    addAllEvents,
    selectedEvents,
    clearSelection,
  } = useEditEventSeriesContext()

  const currentLanguage = i18n.language
  const btnClassName = `${currentLanguage === 'de' ? 'toolbar_btn-de' : 'toolbar_btn-en'}`
  
  const isAllSelected = events && events.length > 0 && selectedEvents.size === events.length

  const handleSelectAll = () => {
    if (events && events.length > 0) {
      selectAllEvents(events)
    }
  }

  const handleAddAll = () => {
    if (events && events.length > 0) {
      addAllEvents(events)
    }
  }
  
  return (
    <div className={`toolbar ${className}`}>
      {!isSelecting ? (
        <SecondaryButton 
          text={t('Event.editEventSeriesModal.select')} 
          onClick={() => setIsSelecting(true)} 
          classNames={btnClassName}
          fullWidth={false}
          disabled={isDisabled}
        />
      ) : (
        <SecondaryButton 
          text={t('Event.editEventSeriesModal.selectAll')} 
          onClick={handleSelectAll}
          disabled={isAllSelected || isDisabled} 
          classNames={btnClassName} 
          fullWidth={false}
        />
      )}

      <SecondaryButton 
        text={t('Event.editEventSeriesModal.addAll')} 
        onClick={handleAddAll}
        fullWidth={false}
        disabled={isDisabled}
      />

      {isSelecting && (<SecondaryButton 
        text={t('common.cancel')} 
        onClick={clearSelection}
        fullWidth={false}
        color="navy"
      />)}
    </div>
  )
}

Toolbar.propTypes = {
  className: PropTypes.string,
  events: PropTypes.array,
  isDisabled: PropTypes.bool,
}